module.exports = __webpack_public_path__ + "assets/assets/images/home/dentists-page-2.bc1cb8c4.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/home/dentists-page-2.svg
// module id = 216
// module chunks = 0